import React from 'react';

/**
 * HopeTeam FB Studio mark: a Facebook-blue rounded tile with a white play triangle (reels)
 * and a small spark (wow content). Kept to two shapes so it stays clean at any size.
 */
export function FbMark({ size = 40, className = '' }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" className={className} role="img" aria-label="FB Studio">
            <defs>
                <linearGradient id="fbm-bg" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="#2d88ff" />
                    <stop offset="1" stopColor="#1466d8" />
                </linearGradient>
            </defs>
            <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#fbm-bg)" />
            {/* play triangle */}
            <path d="M24 22.5c0-2.3 2.5-3.7 4.5-2.5l15.5 9.4c1.9 1.2 1.9 4 0 5.2l-15.5 9.4c-2 1.2-4.5-.2-4.5-2.5z" fill="#fff" />
            {/* spark */}
            <path d="M48 9l1.4 3.6 3.6 1.4-3.6 1.4L48 19l-1.4-3.6L43 14l3.6-1.4z" fill="#fff" />
        </svg>
    );
}

/** Mark + wordmark for the dashboard header. */
export default function FbLogo({ size = 44, subtitle }) {
    return (
        <div className="flex items-center gap-3">
            <FbMark size={size} className="shrink-0 drop-shadow-[0_6px_18px_rgba(24,119,242,0.4)]" />
            <div className="leading-tight">
                <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-sky-300/90">HopeTeam</div>
                <div className="text-xl font-black tracking-tight text-white">
                    FB <span className="text-[#4b9bff]">Studio</span>
                </div>
                {subtitle && <div className="text-xs text-slate-400">{subtitle}</div>}
            </div>
        </div>
    );
}
